import React from 'react';
import { Box, Container, Typography } from '@mui/material';

const OpsHeadSection = () => {
    return (
        <Box
            component="section"
            aria-labelledby="ops-head-heading"
            sx={{
                position: 'relative',
                pt: { xs: 5, md: 6.5, lg: 7 },
                pb: { xs: 4, md: 4.5, lg: 4.5 },
                background: 'linear-gradient(180deg, #FFFFFF 0%, #FAFBFF 100%)',
                overflow: 'hidden',
            }}
        >
            <Container maxWidth="lg">
                <Box sx={{ textAlign: 'center', maxWidth: 980, mx: 'auto', mb: { xs: 3.5, md: 5 } }}>
                    <Typography
                        component="span"
                        sx={{
                            display: 'inline-block',
                            fontSize: { xs: '0.6875rem', sm: '0.75rem' },
                            fontWeight: 700,
                            letterSpacing: '0.18em',
                            textTransform: 'uppercase',
                            color: '#0066FF',
                            bgcolor: 'rgba(0, 102, 255, 0.1)',
                            px: { xs: 1.75, sm: 2.25 },
                            py: 0.75,
                            borderRadius: 999,
                            mb: 2.5,
                        }}
                    >
                        FOR THE OPS HEAD
                    </Typography>

                    <Typography
                        id="ops-head-heading"
                        variant="h2"
                        sx={{
                            fontSize: { xs: '1.75rem', sm: '2.125rem', md: '2.5rem' },
                            fontWeight: 700,
                            lineHeight: 1.2,
                            letterSpacing: '-0.03em',
                            color: '#0F172A',
                            mb: 2.5,
                        }}
                    >
                        What your ops head sees every morning
                    </Typography>

                    <Typography
                        sx={{
                            fontSize: { xs: '1rem', sm: '1.0625rem', md: '1.125rem' },
                            lineHeight: 1.75,
                            color: 'rgba(15, 23, 42, 0.78)',
                            textAlign: 'center',
                        }}
                    >
                        Your ops head opens this every morning and can see who's scheduled, who's checked in, and who hasn't.
                        No calls required. Travel is tracked automatically, session notes come in from the patient's location
                        before the therapist leaves. The field picture is live -- not reconstructed at the end of the day.
                        <br />
                        <br />
                        When the payment cycle closes, the payout queue is already built from what the system confirmed.
                        Not from what therapists reported.
                    </Typography>
                </Box>
            </Container>

            <Box
                sx={{
                    width: '100%',
                    maxWidth: { xs: '100%', sm: 760, md: 880, lg: 1000 },
                    mx: 'auto',
                    px: { xs: 2, sm: 3 },
                    lineHeight: 0,
                }}
            >
                <Box
                    component="img"
                    src={`${process.env.PUBLIC_URL}/assets/Admindashboard.png`}
                    alt="Full-width admin portal screenshot showing exactly what the ops head sees"
                    sx={{
                        width: '100%',
                        height: 'auto',
                        display: 'block',
                        borderRadius: { xs: '14px', md: '20px' },
                    }}
                />
            </Box>
        </Box>
    );
};

export default OpsHeadSection;
